(function ($) {
	
'use strict';

	/**
	 * function for initializing back to top button
	 */
	function initScrollTop() {

		function initScroll() {
			if (initActive) {
				scrollTimer = setTimeout(initScroll, 500);
				return;
			}

			initActive = true;
			scrollTimer = null;

			initWidth = $(window).width();

			if ($(this).scrollTop() > 320) {
				if ($('#top-btn').length < 1) {

					var $content = $(options.contentSelector).first();

					if ($content.length > 0) {
						var $topBtn = $('<a id="top-btn" href="javascript:;" title="' + $.i81n.text('BACKTOTOP') + '">' + $.i81n.text('BACKTOTOP') + '</a>');
						var offset = $content.offset().left + $content.width();

						if (offset === $content.width()) {
							offset = parseFloat($content.css('paddingLeft')) + $content.width();
						}

						$topBtn.css('left', (offset - 54) + 'px');

						$('footer').before($topBtn);

						$topBtn.on('click', scrollAnimated);

						$('#top-btn').fadeIn(500, function () {
							$(this).addClass('top-transparent');
						});
					}
				}
			} else {
				$('#top-btn').remove();
			}

			initActive = false;
		}

		function scrollAnimated() {
			var scrollPos = $(window).scrollTop();

			if (scrollPos > options.anim.minPosFastAnim) {
				scrollPos -= options.anim.fastAnim;
			} else if (scrollPos > options.anim.minPosNormAnim) {
				scrollPos -= options.anim.normAnim;
			} else {
				scrollPos -= options.anim.slowAnim;
			}

			$(window).off('scroll.common');

			$(window).scrollTop(Math.max(0, scrollPos));
			if (scrollPos > 0) {
				setTimeout(scrollAnimated, options.anim.interval);
			} else {
				$(window).on('scroll.common', initScroll);
			}
		}

		function topBtnResize() {
			if ($(window).width() !== initWidth) {
				$('#top-btn').remove();
				clearTimeout(scrollTimer);
				scrollTimer = setTimeout(initScroll, 100);
			}
		}


		var options = $.extend(true,
				{
					contentSelector: '#wrapper, .wrapper',
					anim: {
						minPosFastAnim: 1500, // fast animation until the defined scroll position
						minPosNormAnim: 300, // normal animation until the defined scroll position
						fastAnim: 500, // fast animation scroll pixels
						normAnim: 150, // normal animation scroll pixels
						slowAnim: 20, // slow animation scroll pixels
						interval: 25	// scroll interval, used for the setTimeout call
					}
				},
				($.morejs_options.scrollToTop || {})
				);

		var scrollTimer = null;
		var initWidth = 0;
		var initActive = false;
		$(window).off('resize.common').on('resize.common', topBtnResize)
				.off('scroll.common').on('scroll.common', initScroll);

		initScroll();
	} // fn.initScrollTop
	

	/**
	 * initialize accordions, sliders, image lighbox
	 * handle invalid images and check video tags.
	 * Animate click handler for clickable elements
	 * @param {object} options
	 * @returns {undefined}
	 */
	$.commonElementInit = function (options) {
		options = $.extend({
			scrollInit: true
		}, options || {});
		/**
		 * initalize mainpage accordion sections 
		 */
		$('.mp-section').mpAccordion($.morejs_options.mpAccordion);

		/**
		 *  initialize img/video/product sliders
		 */
		$('body').sliderInit();

		/**
		 * Lightbox handler for images
		 */
		if ($.morejs_options.commonElementInit.initImgLightbox) {
			var $img4Lightbox = $('.previewslide-img img, .image-slider-container .slide img').not('.image-slider-container .active-image-container + .image-slider .slide img');
			if ($img4Lightbox.length > 0) {

				$.loadLightboxJs(function () {
					function showLightbox() {
						$img4Lightbox.off('click');
						// clone image and lightbox the clone
						var $original = $(this);
						var lb = $('<div style="max-width: 100%; max-height: 100%;" />');
						var clone = $(this).clone();
						var fullImg = clone.attr('data-imgfull');
						if (typeof fullImg === 'string' && fullImg !== '') {
							clone = $('<img src="' + fullImg + '" >');
							// use the original image if loading the big image fails
							clone.error(function (e) {
								clone.attr('src', $original.attr('src'));
							});
							clone.css({'max-width': '100%', 'max-height': '85vh', width: 'auto', height: 'auto'});
							clone.one('load', function () {

								lb.lightbox_me_start(clone, {
									onClose: function () {
										lb.remove();
										$img4Lightbox.on('click', showLightbox);
									}
								});
							}).attr('src', fullImg);
						} else {
							if (clone.width() <= $(this).parent().width() + 50 &&
									clone.height() <= $(this).parent().height() + 50) {
								clone.width($(this).width() * 1.3);
								clone.height($(this).height() * 1.3);
							} else {
								clone.width($(this).width());
								clone.height($(this).height());
							}
							clone.css({'max-width': '100%', 'max-height': '100%'});
							lb.lightbox_me_start(clone, {
								onClose: function () {
									lb.remove();
									$img4Lightbox.on('click', showLightbox);
								}
							});
						}

					}

					$img4Lightbox.css('cursor', 'pointer')
							.off('click')
							.on('click', showLightbox);
				});
			}
		}

		/**
		 * History back handling
		 */
		$('.entrypreview, .eventpreview, .ws-article').not('.nodetail').initHistoryHandler();
		/**
		 * History back button click handler
		 */
		$('#back-btn').off('click').on('click', function () {
			history.back();
			return false;
		});

		/**
		 * initializing 'back to top' scroll button handling
		 */
		if (options.scrollInit) {
			initScrollTop();
		}

		/**
		 * missing img error handler
		 * ! we have to use the each() member cause $("img").error(...) did not work in IE!
		 */
		$('img').each(function () {
			// if title attribute is empty use the alt attribute as title also
			if (typeof $(this).attr('title') === 'undefined' && $(this).attr('alt') !== '') {
				$(this).attr('title', $(this).attr('alt'));
			}
			$(this).off('error')
					.on('error', function () {
						$(this).attr('title', $(this).attr('src')).
								attr('src', '/img/notfound.png');
					});
			$(this).attr('src', $(this).attr('src'));
		});
		/**
		 * append a link for the video for browsers that can't play the video 
		 */
		$('video').each(function () {
			$(this).attr('preload', 'none');
			if ($(this).children('a').length === 0) {
				$(this).append('<br />Ihr Browser unterstützt die direkte Ausgabe von Videos nicht - <a href="' + $(this).find('>:first-child').attr('src') + '" target="_blank">Download des Videos</a>');
			}
		});

		/**
		 * prevent window.opener.location attacks see: https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
		 */
		$('a[target="_blank"]').attr('rel', 'noopener noreferrer');

		/**
		 * animate links and buttons
		 */
		function animateClickHandler() {
			$(this).animate({
				opacity: 0
			}, 100, function () {
				$(this).animate({
					opacity: 1
				}, 10);
			});
		}
		$('input[type="submit"], input[type="button"], button, a')
				.off('click.animate')
				.on('click.animate', animateClickHandler);


		// replace <a> with <span> if the element have an empty data-pageid
		$('article h1 a[data-pageid=""], article h2 a[data-pageid=""], article h3 a[data-pageid=""], article h4 a[data-pageid=""]').each(function(){
			var html = $(this).html();
			$(this).replaceWith('<span>' + html + '</span>');
		});

		// shop product preview
		$('[id^="QUERYCONF-PRODUCTS-"]').each(function() {
			$(this).shopPreview();
		});

		// execute the customIni function if defined
		if (typeof $.morejs_options.commonElementInit.customInit === 'function') {
			$.morejs_options.commonElementInit.customInit();
		}
	}; // $.commonElementInit

}(jQuery));